(function () {
    // prettier-ignore
    var couponItemTemplate = ''+
        '<li data-coupon-id="{{cpId}}" data-enc-coupon-id="{{encCpId}}">'+
            '<div class="cp-box {{_state}}">'+
                '<div class="cp-cont">'+
                    '{{#if cpPartnerType === "ENT"}}'+
                        '<p class="cp-badge">사업자몰</p>' +
                    '{{#else}}'+
                        '<p class="cp-badge">LGE.COM</p>' +
                    '{{/if}}'+
                    '<em class="title">{{_cpDiscVal}}<i class="unit">{{_cpDiscUnit}}</i></em>'+
                    '<p class="description">{{cpDispName}}</p>'+
                        '<div class="info">'+
                        '{{#if cpPartnerType === "ENT"}}'+
                            '{{#if _leftDayCnt > 30}}'+
                            '   <p>{{_cpPublEdDay}} 종료</p>'+
                            '{{#else}}'+
                                '<p>{{_cpPublEdDay}} 종료({{_leftDayCnt}}일전)</p>'+
                            '{{/if}}'+
                        '{{#else}}'+
                            '<p>{{_cpPublEdDay}} 종료({{_leftDayCnt}}일전)</p>'+
                        '{{/if}}'+
                        '</div>'+
                    '<div class="cp-btn">'+
                        '<button type="button" class="download" {{#if isDownload==="N"}} data-contents="{{cpDispName}}" {{/if}}>'+
                            '<em>{{#if isDownload==="N"}}다운로드{{#else}}발급<br>완료{{/if}}</em>'+
                        '</button>'+
                    '</div>'+
                '</div>'+
            '<div class="cp-open-view">'+
                '<a href="#n" class="text" role="button">상세정보</a>'+
                '<div class="cp-cont-view">'+
                    '<strong class="sub-tit">{{#if isDownload==="N"}}발급기간{{#else}}유효기간{{/if}}</strong>'+
                    '<div class="sub-cont">{{_cpPublStDate}} 부터 <br>{{_cpPublEdDate}} 까지</div>'+
                        '{{#if cpDiscMinPrice !== "" }}'+
                        '<strong class="sub-tit">할인조건</strong>'+
                    '<div class="sub-cont">{{cpDiscMinPrice}}</div>'+
                    '{{/if}}'+
                    '{{#if cpPartnerType === "ENT"}}'+
                    '<strong class="sub-tit">적용모델</strong>'+
                    '<div class="sub-cont">사업자몰 전체모델<br>일부모델은 적용대상에서 제외될 수 있습니다.</div>'+
                        '{{/if}}'+
                    '</div>'+
                '</div>'+
            '</div>'+
        '</li>';

    //BTOCSITE-37530 : [쿠폰] 기획전 페이지 내 제휴 쿠폰 노출 및 다운로드 기능 개발 요청
    var affCpItemTemplate =
        '<li data-affCoupon-id="{{affCpId}}" data-enc-coupon-id="{{encCpId}}">'+
            '<div class="cp-box {{_state}}">'+
                '<div class="cp-cont">'+
                    '<p class="cp-badge">제휴</p>' +
                    '<em class="title">{{_rprsntMsg}}</em>'+
                    '<p class="description">{{affCpDispName}}</p>'+
                    '<div class="info">'+
                        '<p>{{#if downloadStatus==="D"}}{{affCpNowDay}}{{#else}}{{affCpUseNowDay}}{{/if}}</p>'+
                    '</div>'+
                    '{{#if downloadStatus === "U" }}'+
                    '<p class="cp-code">쿠폰코드 : '+
                        '<span class="num">{{affPublCode}}</span>'+
                        '<button type="button" class="copy-btn"><em class="blind">쿠폰번호 복사</em></button>'+
                    '</p>'+
                    '{{/if}}'+
                    '<div class="cp-btn">'+
                        '<button type="button" class="download" {{#if downloadStatus==="D"}} data-contents="{{affCpDispName}}" {{/if}}>'+
                        '<em>{{#if downloadStatus==="D"}}다운로드{{#else}}발급<br>완료{{/if}}</em>'+
                        '</button>'+
                    '</div>'+
                '</div>'+
                '<div class="cp-open-view">'+
                    '<a href="#n" class="text" role="button">상세정보</a>'+
                    '<div class="cp-cont-view">'+
                        '<strong class="sub-tit">{{#if downloadStatus==="D"}}발급기간{{#else}}유효기간{{/if}}</strong>'+
                        '{{#if downloadStatus === "D" }}'+
                        '<div class="sub-cont">{{affCpPublStDate}} 부터 <br>{{affCpPublEdDate}} 까지</div>'+
                        '{{/if}}'+
                        '{{#if downloadStatus === "U" }}'+
                        '<div class="sub-cont">{{affPublUseStDate}} 부터 <br>{{affPublUseEdDate}} 까지</div>'+
                        '{{/if}}'+
                        '<strong class="sub-tit">혜택정보</strong>'+
                        '<div class="sub-cont">{{benefitMsg}}</div>'+
                        ' {{#if linkUrl }} <div class="btn-area">' +
                        '<a href="{{linkUrl}}" class="btn-text" target="_blank" title="새창열림">이벤트 페이지 이동</a>' +
                        '</div> {{/if}}' +
                        '<ul class="bullet-list">'+
                            '<li class="b-txt">{{affCpAttention}}</li>' +
                        '</ul>' +
                    '</div>'+
                '</div>'+
            '</div>'+
        '</li>';
    
    var linkHost = window.LGEAPPHostName === "localhost" ? "https://www.lge.co.kr" : "";

    var planEventTypeCpn = "";

    var isDev =
        location.href.indexOf("KRC0043.html") >= 0
            ? true
            : false;

    var pdpCoupon = {
        variable: {
            couponList: [],
            couponCnt: 0,
            affCouponList: [],
            affCouponCnt: 0
        },
        el: {
            $couponWrap: null,
            $popCoupon: null,
            $popCouponList: null,
            $tabs: null,
            $stickyTab: null,
            $popAffCoupon: null,
            $popAffCouponList: null,
            $couponPop: null
        },
        selector: {
            couponWrap: ".coupon-wrap",
            popCoupon: "#coupon-pop #tab1",
            popCouponList: ".coupon-list",
            tabs: "#coupon-pop .coupon-down-pop .tabs",
            stickyTab : "#coupon-pop .coupon-down-pop .ui_stickyTab",
            popAffCoupon: "#coupon-pop #tab2",
            couponPop: "#coupon-pop"
        },
        setProperty: function () {
            this.$couponWrap = $(this.selector.couponWrap);
            this.$popCoupon = $(this.selector.popCoupon);
            this.$popCouponList = this.$popCoupon.find(this.selector.popCouponList);
            this.$tabs = $(this.selector.tabs);
            this.$stickyTab = $(this.selector.stickyTab);
            this.$popAffCoupon = $(this.selector.popAffCoupon);
            this.$popAffCouponList = this.$popAffCoupon.find(this.selector.popCouponList);
            this.$couponPop = $(this.selector.couponPop);
        },

        init: function (el) {
            this.el.$couponWrap = $(el);

            if (!this.el.$couponWrap.length > 0) {
                return;
            }

            planEventTypeCpn = this.el.$couponWrap.attr("data-plan-event-type");

            this.setProperty();

            this.setCouponTab();

            this.loginCheck();

            this.bindEvents();
        },

        /**
         * @method setCouponTab
         * @return [사용할 수 있는쿠폰 팝업 > lge.com, 제휴 텝 표시 처리 ]
         */
        setCouponTab: function () {
            var cpInclYn = this.el.$couponWrap.attr("data-coupon-incl-yn");
            var affCpInclYn = this.el.$couponWrap.attr("data-affCoupon-incl-yn");
            var couponId = this.el.$couponWrap.attr("data-coupon-id");

            if((cpInclYn !== 'undefined' && cpInclYn == 'Y') || (cpInclYn == undefined && couponId != "")){
                this.$tabs.children("li").eq(0).css("display", "inline-block");
                this.requestPdpCoupon();
            }

            if(affCpInclYn !== 'undefined' && affCpInclYn == 'Y'){
                this.$tabs.children("li").eq(1).css("display", "inline-block");

                if (this.$tabs.children("li").eq(0).css('display') === 'none') {
                    this.$stickyTab.vcTab("select", 1);
                }

                this.requestAffCoupon();
            }
        },

        bindEvents: function () {
            //상세 보기 토글
            $("body").on("click", ".cp-open-view > .text", function () {
                $(this).parents(".cp-box").toggleClass("active");
            });

            //BTOCSITE-37530 : 텝 클릭 시 처리
            this.$stickyTab.on("stickyTabchange", function(e,_obj) {
                var idx = _obj.selectedIndex;

                if(idx == 0){
                    $("#coupon-pop #affCpBtn").css("display", "none");

                    if (planEventTypeCpn == "b2b") {
                        if ($("#coupon-pop #tab1 .coupon-list").find(".business-before").length === 0) {
                            $("#coupon-pop #lgeCpBtn").css("display", "none");
                        } else {
                            $("#coupon-pop #lgeCpBtn").css("display", "inline-block");
                        }
                    } else {
                        if ($("#coupon-pop #tab1 .coupon-list").find(".lge-before").length === 0) {
                            $("#coupon-pop #lgeCpBtn").css("display", "none");
                        } else {
                            $("#coupon-pop #lgeCpBtn").css("display", "inline-block");
                        }
                    }

                } else {
                    $("#coupon-pop #lgeCpBtn").css("display", "none");

                    if ($("#coupon-pop #tab2 .coupon-list").find(".partner-before").length === 0) {
                        $("#coupon-pop #affCpBtn").css("display", "none");
                    } else {
                        $("#coupon-pop #affCpBtn").css("display", "inline-block");
                    }
                }
            });

            //BTOCSITE-41782 : [제휴쿠폰] 기획전 내 제휴 쿠폰 기능 수정 요청(쿠폰코드복사)
            $("body").on("click", ".copy-btn", function () {
                var affCpCd = $(this).closest(".cp-code").find(".num").text();
                vcui.dom.copyToClipboard(affCpCd, {
                    container: this,
                    onSuccess: function () {
                        $(window).trigger("toastshow", "복사 완료되었습니다.");
                    }
                });
            });

            this.$popCoupon.on("click", ".download", $.proxy(this.handler.clickBtnDownCoupon, this));

            //BTOCSITE-37530 : [쿠폰] 기획전 페이지 내 제휴 쿠폰 노출 및 다운로드 기능 개발 요청 S
            this.$popAffCoupon.on("click", ".download", $.proxy(this.handler.clickBtnDownAffCoupon, this));

            this.$couponPop.on("click", "#lgeCpBtn", $.proxy(this.handler.clickBtnDownAllCoupon, this));

            this.$couponPop.on("click", "#affCpBtn", $.proxy(this.handler.clickBtnDownAllAffCoupon, this));
            //BTOCSITE-37530 : [쿠폰] 기획전 페이지 내 제휴 쿠폰 노출 및 다운로드 기능 개발 요청 E

            $('.lls-frame-bottom').on("click", ".btn-coupon", $.proxy(this.handler.clickBtnLLS, this));
        },
        handler: {
            /**
             * @callback clickBtnDownCoupon
             * @param {*} e
             * @return {myCallback} [사용할 수 있는쿠폰 팝업 > LGE.COM > 다운로드 아이콘 클릭 시 다운로드 ]
             */
            clickBtnDownCoupon: function (e) {
                if ($(e.currentTarget).closest(".cp-box").hasClass("lge-after") || $(e.currentTarget).closest(".cp-box").hasClass("business-after")) {
                    return;
                }
                var couponId = $(e.currentTarget).closest("li").attr("data-coupon-id");
                var encCouponId = $(e.currentTarget).closest("li").attr("data-enc-coupon-id");
                var unifyId = vcui.Cookie.get("UNIFY_ID");
                if (unifyId === "" && !isDev) {
                    this.goLogin();
                } else {
                	lgkorUI.showLoading();
                    this.requestPdpGetCoupon(couponId, encCouponId);
                }
            },
            /**
             * @callback clickBtnDownAllCoupon
             * @param {*} e
             * @return {myCallback} [사용할 수 있는쿠폰 팝업 > LGE.COM > 쿠폰모두받기 버튼 클릭 시 모두 다운로드 ]
             */
            clickBtnDownAllCoupon: function () {
                var unifyId = vcui.Cookie.get("UNIFY_ID");
                if (unifyId === "" && !isDev) {
                    this.goLogin();
                } else {
                	lgkorUI.showLoading();
                    this.requestPdpGetAllCoupon();
                }
            },

            /**
             * @callback clickBtnDownAffCoupon
             * @param {*} e
             * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 제휴 > 쿠폰 다운로드 아이콘 클릭 시 다운로드 ]
             */
            clickBtnDownAffCoupon: function (e) {
                if ($(e.currentTarget).closest(".cp-box").hasClass("partner-after")) {
                    return;
                }
                var affCpId = $(e.currentTarget).closest("li").attr("data-enc-coupon-id");
                var unifyId = vcui.Cookie.get("UNIFY_ID");
                if (unifyId === "" && !isDev) {
                    this.goLogin();
                } else {
                	lgkorUI.showLoading();
                    this.requestDownAffCoupon(affCpId);
                }
            },

            /**
             * @callback clickBtnDownAllAffCoupon
             * @param {*} e
             * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 제휴 > 쿠폰 모두받기 버튼 클릭 시 모두 다운로드 ]
             */
            clickBtnDownAllAffCoupon: function () {
                var unifyId = vcui.Cookie.get("UNIFY_ID");
                if (unifyId === "" && !isDev) {
                    this.goLogin();
                } else {
                	lgkorUI.showLoading();
                    this.requestDownAllAffCoupon();
                }
            },

        },
        /**
         * @method loginCheck
         * @return {myCallback} [로그인 체크 > 로그인 Y : 쿠폰보기 팝업 / 로그인 N : 로그인 페이지로 이동]
         */
         loginCheck: function () {
            var param = {};
            param.userId = vcui.Cookie.get("UNIFY_ID");
            var couponBtn = $('.coupon-btn');

            if (param.userId != "") {
                couponBtn.append('<button type="button" data-href="#coupon-pop" data-control="modal" class="btn-link">쿠폰보기</button>');
                $('.coupon-bottom').append('<button type="button" data-href="#coupon-pop" data-control="modal" class="btn-coupon" title="사용할 수 있는 쿠폰이 있어요.">'+
                '<div class="button-badge">N</div></button>');
            }else{
                couponBtn.append('<a href="/sso/member/login" class="btn-link">쿠폰보기</a>');
                $('.coupon-bottom').append('<a href="/sso/member/login" class="btn-coupon" title="사용할 수 있는 쿠폰이 있어요.">'+
                '<div class="button-badge">N</div></a>');
            }
        },
        /**
         * @method requestPdpCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > LGE.COM > 쿠폰 리스트 ajax 호출 ]
         */
        requestPdpCoupon: function () {
            var couponId = this.el.$couponWrap.attr("data-coupon-id");
            var ajaxUrl = this.el.$couponWrap.attr("data-coupon-list-ajax");
            var param = {};

            param.userId = vcui.Cookie.get("UNIFY_ID");
            param.couponId = couponId;

            if (planEventTypeCpn == "b2b") {
                param.planEventType = planEventTypeCpn;
            }

            if(typeof memberDiscountPrice !== 'undefined') {
                param.mPrice = memberDiscountPrice;
            }

            lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
                    if (result.result === "S") {
                        //success
                        this.variable.couponCnt = result.total;
                        this.variable.couponList = result.data.couponList;

                        this.renderCounponList();

                        if(typeof memberDiscountPrice !== 'undefined') {
                            var $maxPrice = $('.price-detail-item .max-price');
                            var $maxPriceCouponText = $('.coupon-detail-item .text span');
                            var $maxPriceCouponPrice = $('.coupon-detail-item .content span');
                            var $maxPriceCoupon = $('.price-detail-item.coupon-detail-item');

                            var $userCouponTotal = $('.total-coupon-payment');
                            var $userCouponPrice = $('.total-coupon-payment .payment .price');

                            var dataMaxPrice = result.data.maxCpPrice;
                            var dataMaxPriceNumber = dataMaxPrice.replace(',', '');

                            var dataUserCouponPrice = result.data.userCpPrice;
                            var dataUserCouponPriceNumber = dataUserCouponPrice.replace(',', '');

                            // 최대 할인가
                            if (dataMaxPrice && lgkorUI.stringToBool(loginFlag)) {
                                $maxPrice.text(vcui.number.addComma((memberDiscountPrice - Number(dataMaxPriceNumber)) + '원'));
                                $maxPriceCouponText.text(result.data.maxCpNm);
                                $maxPriceCouponPrice.text('-' + dataMaxPrice + '원');
                                $maxPrice.closest('li').show();
                                $maxPriceCoupon.show();
                            }

                            // 쿠폰 적용가
                            if (dataUserCouponPrice && lgkorUI.stringToBool(loginFlag)) {
                                $userCouponPrice.data('price', memberDiscountPrice - Number(dataUserCouponPriceNumber));
                                $userCouponPrice.text(vcui.number.addComma((memberDiscountPrice - Number(dataUserCouponPriceNumber)) + '원'));

                                // 쿠폰 적용가, 사용자 쿠폰 적용 영역 로그인 전/후 노출 영역 처리
                                if (lgkorUI.stringToBool(loginFlag)) {
                                    $userCouponTotal.show();
                                }
                            }
                        }
                    }
                }.bind(this),
                true,
                true
            );
        },
        /**
         * @method requestPdpGetCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > LGE.COM > 쿠폰 받기 ajax 호출 ]
         */
        requestPdpGetCoupon: function (couponId, encCouponId) {
            var ajaxUrl = this.el.$couponWrap.attr("data-coupon-get-ajax");
            var param = {};
            param.couponId = couponId;
            param.encCouponId = encCouponId;
            param.userId = vcui.Cookie.get("UNIFY_ID");

            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                param,
                function (result) {
                	lgkorUI.hideLoading();
                    if (result.code === "0000") {
                        //success
                        var obj = { title: "" };
                        obj = $.extend(obj, { title: "쿠폰을 받았습니다." });
                        lgkorUI.alert(null, obj);

                        this.requestPdpCoupon();
                    } else {
                        //fail
                        var obj = $.extend(obj, { title: "쿠폰 다운로드에 실패 하였습니다.<br/>잠시 후 재시도 해주세요." });
                        lgkorUI.alert(null, obj);
                    }
                }.bind(this),
                true,
                true
            );
        },
        /**
         * @method requestPdpGetAllCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > LGE.COM > 쿠폰 모두 받기 ajax 호출 ]
         */
        requestPdpGetAllCoupon: function () {
            var ajaxUrl = this.el.$couponWrap.attr("data-coupon-get-all-ajax");

            var oCouponId = [];
            var encCouponId = [];
            if (planEventTypeCpn == "b2b") {
                $(".cp-box.business-before").each(function () {
                    oCouponId.push($(this).closest("li").attr("data-coupon-id"));
                    encCouponId.push($(this).closest("li").attr("data-enc-coupon-id"));
                });
            } else {
                $(".cp-box.lge-before").each(function () {
                    oCouponId.push($(this).closest("li").attr("data-coupon-id"));
                    encCouponId.push($(this).closest("li").attr("data-enc-coupon-id"));
                });
            }

            if (oCouponId.length === 0) {
                var obj = { title: "" };
                obj = $.extend(obj, { title: "다운로드할 수 있는 쿠폰이 없습니다." });
                lgkorUI.alert(null, obj);
                return;
            }

            var param = {};
            param.couponId = oCouponId;
            param.encCouponId = encCouponId;
            param.userId = vcui.Cookie.get("UNIFY_ID");

            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                param,
                function (result) {
                	lgkorUI.hideLoading();
                    if (result.code === "0000") {
                        //success
                        var obj = { title: "" };
                        if (planEventTypeCpn == "b2b") {
                            obj = $.extend(obj, { title: "다운로드 가능한 모든 사업자몰 쿠폰을<br/>다운로드 하였습니다." });
                        } else {
                            obj = $.extend(obj, { title: "다운로드 가능한 모든 쿠폰을<br/>다운받았습니다." });
                        }
                        lgkorUI.alert(null, obj);

                        this.requestPdpCoupon();
                    } else {
                        //fail
                        var obj = $.extend(obj, { title: "쿠폰 다운로드에 실패 하였습니다.<br/>잠시 후 재시도 해주세요." });
                        lgkorUI.alert(null, obj);
                    }
                }.bind(this),
                true,
                true
            );
        },
        /**
         * @method renderCounponList
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > LGE.COM > 쿠폰 리스트 호출]
         */
        renderCounponList: function () {
            this.$popCouponList.empty();

            for (var i = 0; i < this.variable.couponCnt; i++) {
                var item = this.variable.couponList[i];

                if (item.cpDiscPrice === 0) {
                    item._cpDiscVal = item.cpDiscRate;
                    item._cpDiscUnit = "%";
                } else {
                    item._cpDiscVal = vcui.number.addComma(item.cpDiscPrice);
                    item._cpDiscUnit = "원";
                }

                if (item.cpPublEdDate) {
                    var edDate = item.cpPublEdDate.replace(/-/gi, "/");

                    item._cpPublEdDay = vcui.date.format(new Date(edDate), "yyyy년 M월 d일");
                    item._cpPublEdDate = vcui.date.format(new Date(edDate), "yyyy년 M월 d일 hh:mm");
                } else {
                    item._cpPublEdDay = "";
                    item._cpPublEdDate = "";
                }

                if (item.cpPublStDate) {
                    var stDate = item.cpPublStDate.replace(/-/gi, "/");

                    item._cpPublStDate = vcui.date.format(new Date(stDate), "yyyy년 M월 d일 hh:mm");
                } else {
                    item._cpPublStDate = "";
                }

                if (planEventTypeCpn == "b2b") {
                    if (item.ordFlag === "A") {
                        item._state = "business-before";
                    } else {
                        item._state = "business-after";
                    }
                } else {
                    if (item.ordFlag === "A") {
                        item._state = "lge-before";
                    } else {
                        item._state = "lge-after";
                    }
                }

                item._leftDayCnt = String(item.leftDayCnt);
                item._cpDiscMinPrice = vcui.number.addComma(item.cpDiscMinPrice);
                item._cpDiscMaxPrice = vcui.number.addComma(item.cpDiscMaxPrice);
                
                if (item.ordFlag === "A") {
                    this.$popCouponList.eq(0).append(vcui.template(couponItemTemplate, item).replace(/&lt;/gi, "<")
                            .replace(/&gt;/gi, ">").replace(/(?:\r\n|\r|\n)/g, '<br />'));
                } else {
                    this.$popCouponList.eq(1).append(vcui.template(couponItemTemplate, item).replace(/&lt;/gi, "<")
                            .replace(/&gt;/gi, ">").replace(/(?:\r\n|\r|\n)/g, '<br />'));
                }
            }

            if (this.$popCouponList.eq(0).find("li").length === 0) {
                $("#coupon-pop #tab1 .sub-title").eq(0).hide();
                this.$popCouponList.eq(0).remove();
                $("#coupon-pop #lgeCpBtn").css("display", "none");
            } else {
                $("#coupon-pop #tab1 .sub-title").eq(0).show();

                if($("#coupon-pop .tabs").children().eq(0).hasClass("on")){
                    $("#coupon-pop #lgeCpBtn").css("display", "inline-block");
                } else {
                    $("#coupon-pop #lgeCpBtn").css("display", "none");
                }
            }

            if (this.$popCouponList.eq(1).find("li").length === 0) {
                $("#coupon-pop #tab1 .sub-title").eq(1).hide();
                this.$popCouponList.eq(1).hide();
            } else {
                $("#coupon-pop #tab1 .sub-title").eq(1).show();
                this.$popCouponList.eq(1).show();
            }
        },

        /**
         * @method requestAffCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 제휴 > 쿠폰 리스트 ajax 호출 ]
         */
        requestAffCoupon: function () {
            var affCpId = this.el.$couponWrap.attr("data-affCoupon-id");
            var ajaxUrl = this.el.$couponWrap.attr("data-affCoupon-list-ajax");
            var param = {};

            param.userId = vcui.Cookie.get("UNIFY_ID");
            param.couponId = affCpId;

            lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
                    if (result.result === "S") {
                        //success
                        this.variable.affCouponCnt = result.total;
                        this.variable.affCouponList = result.data.affCouponList;

                        this.renderAffCounponList();

                    }
                }.bind(this),
                true,
                true
            );
        },

        //BTOCSITE-37530 : [쿠폰] 기획전 페이지 내 제휴 쿠폰 노출 및 다운로드 기능 개발 요청 S
        /**
         * @method renderAffCounponList
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 제휴 > 제휴 쿠폰 리스트 호출]
         */
        renderAffCounponList: function () {
            this.$popAffCouponList.empty();

            for (var i = 0; i < this.variable.affCouponCnt; i++) {
                var item = this.variable.affCouponList[i];

                var mainTxt = item.rprsntMsg;

                if (mainTxt.indexOf("원") > 0) {
                    item._rprsntMsg = mainTxt.replace("원", "<i class=unit>원</i>");
                }else if (mainTxt.indexOf("%") > 0) {
                    item._rprsntMsg = mainTxt.replace("%", "<i class=unit>%</i>");
                } else {
                    item._rprsntMsg = mainTxt;
                }

                if (item.downloadStatus === "D") {
                    item._state = "partner-before";
                    this.$popAffCouponList.eq(0).append(vcui.template(affCpItemTemplate, item).replace(/&lt;/gi, "<")
                        .replace(/&gt;/gi, ">").replace(/(?:\r\n|\r|\n)/g, '<br />'));
                } else {
                    item._state = "partner-after";
                    this.$popAffCouponList.eq(1).append(vcui.template(affCpItemTemplate, item).replace(/&lt;/gi, "<")
                        .replace(/&gt;/gi, ">").replace(/(?:\r\n|\r|\n)/g, '<br />'));
                }

            }

            if (this.$popAffCouponList.eq(0).find("li").length === 0) {
                $("#coupon-pop #tab2 .sub-title").eq(0).hide();
                this.$popAffCouponList.eq(0).remove();
                $("#coupon-pop #affCpBtn").css("display", "none");
            } else {
                $("#coupon-pop #tab2 .sub-title").eq(0).show();

                if($("#coupon-pop .tabs").children().eq(1).hasClass("on")){
                    $("#coupon-pop #affCpBtn").css("display", "inline-block");
                } else {
                    $("#coupon-pop #affCpBtn").css("display", "none");
                }
            }

            if (this.$popAffCouponList.eq(1).find("li").length === 0) {
                $("#coupon-pop #tab2 .sub-title").eq(1).hide();
                this.$popAffCouponList.eq(1).hide();
            } else {
                $("#coupon-pop #tab2 .sub-title").eq(1).show();
                this.$popAffCouponList.eq(1).show();
            }
        },

        /**
         * @method requestDownAffCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 제휴 > 쿠폰 받기 ajax 호출 ]
         */
        requestDownAffCoupon: function (affCpId) {
            var ajaxUrl = this.el.$couponWrap.attr("data-affCoupon-get-ajax");
            var param = {};
            param.affCpId = affCpId;
            param.userId = vcui.Cookie.get("UNIFY_ID");

            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                param,
                function (result) {
                	lgkorUI.hideLoading();
                    if (result.code === "0000") {
                        //success
                        var obj = { title: "" };
                        obj = $.extend(obj, { title: "쿠폰을 받았습니다." });
                        lgkorUI.alert(null, obj);

                        this.requestAffCoupon();
                    } else {
                        //fail
                        console.log("MSG : " + result.data.jobDoErrMsg);
                        var obj = $.extend(obj, { title: "쿠폰 다운로드에 실패 하였습니다.<br/>잠시 후 재시도 해주세요." });
                        lgkorUI.alert(null, obj);
                    }
                }.bind(this),
                true,
                true
            );
        },

        /**
         * @method requestDownAllAffCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 제휴 > 쿠폰 모두 받기 ajax 호출 ]
         */
        requestDownAllAffCoupon: function () {
            var ajaxUrl = this.el.$couponWrap.attr("data-affCoupon-get-all-ajax");

            var oAffCpId = [];
            $("#tab2 .cp-box.partner-before").each(function () {
                oAffCpId.push($(this).closest("li").attr("data-enc-coupon-id"));
            });

            if (oAffCpId.length === 0) {
                var obj = { title: "" };
                obj = $.extend(obj, { title: "다운로드할 수 있는 쿠폰이 없습니다." });
                lgkorUI.alert(null, obj);
                return;
            }

            var param = {};
            param.affCpId = oAffCpId;
            param.userId = vcui.Cookie.get("UNIFY_ID");

            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                param,
                function (result) {
                	lgkorUI.hideLoading();
                    if (result.code === "0000") {
                        //success
                        var obj = { title: "" };
                        obj = $.extend(obj, { title: "다운로드 가능한 모든 쿠폰을<br/>다운받았습니다." });
                        lgkorUI.alert(null, obj);

                        this.requestAffCoupon();
                    } else {
                        //fail
                        var obj = { title: "" };
                        obj = $.extend(obj, { title: result.data.jobDoErrMsg });
                        lgkorUI.alert(null, obj);
                    }
                }.bind(this),
                true,
                true
            );
        },
        //BTOCSITE-37530 : [쿠폰] 기획전 페이지 내 제휴 쿠폰 노출 및 다운로드 기능 개발 요청 E
        /**
         * @method goLogin
         * @return {myCallback} [로그인 화면으로 이동]
         */
        goLogin: function () {
            var obj = { title: "" };
            obj = $.extend(obj, {
                title: "로그인 후 받으실 수 있습니다.",
                ok: function () {
                    location.href = linkHost + "/sso/member/login?state=" + encodeURIComponent(location.href.replace(location.origin, ""));
                },
            });

            lgkorUI.alert(null, obj);
        },
    };

    function funcReady() {
        pdpCoupon.init(".coupon-wrap");

        $('#sauce').one('load', function(){
            var iframeH = $('#sauce').height();
            $('.coupon-bottom').css({display : 'block' ,top : iframeH - 220});
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRC0043', isFirstLoad: true, fn: function () {
                funcReady();
            }
        });
    }

    // 기획전이 b2b 일 경우 노출되는 쿠폰 팝업 탭이 1개 일때 탭은 비노출 처리
    function couponTabView() {
        var tabCnt = $("#couponTabs").css("display","block").size();		// 노출된 탭 숫자 확인

        if (planEventTypeCpn == "b2b" && tabCnt == 1) {			// 쿠폰이 없는 경우는 tabCnt가 0 임으로 1에 대해서만 처리
            $("#couponTabs").hide();
        }
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function () {
        SAVE_COMPONENT_PDP_DOM_MNG();

        funcReady();
        couponTabView();
    });
})();